<template>
  <div>
    <div
      v-if="desktopAltEnabled || controlAltDesktopEnabled"
      tabindex="0"
      class="alt-grid-view-buttons"
    >
      <button
        class="standard-button"
        aria-label="Change grid view to 4 products per row"
        :disabled="selectedGridView === 4"
        @click="changeGridView(4)"
      >
        <img
          :src="standardImage"
        >
      </button>
      <button
        :disabled="selectedGridView === 6"
        :aria-label="`Change grid view to 6 products per row`"
        @click="changeGridView(6)"
      >
        <img :src="smallImage">
      </button>
    </div>
    <div
      v-else-if="isPhone"
      tabindex="0"
      class="alt-grid-view-buttons-mew"
    >
      <button
        v-if="!controlAltPhoneEnabled"
        class="standard-button"
        aria-label="Change grid view to 2 products per row"
        :disabled="selectedGridView === 2"
        @click="changeGridView(2)"
      >
        <img :src="standardImage">
      </button>
      <button
        :disabled="selectedGridView === (controlAltPhoneEnabled ? 1 : noOfPhoneProds)"
        :aria-label="`Change grid view to ${controlAltPhoneEnabled ? 1 : noOfPhoneProds} products per row`"
        @click="changeGridView(controlAltPhoneEnabled ? 1 : noOfPhoneProds)"
      >
        <template v-if="phoneAltEnabled1">
          <img :src="smallImage">
        </template>
        <template v-else>
          <img :src="portraitImage">
        </template>
      </button>
      <button
        v-if="controlAltPhoneEnabled"
        class="standard-button"
        aria-label="Change grid view to 2 products per row"
        :disabled="selectedGridView === 2"
        @click="changeGridView(2)"
      >
        <img :src="standardImage">
      </button>
      <button
        v-if="controlAltPhoneEnabled"
        :disabled="selectedGridView === 3"
        :aria-label="`Change grid view to 3 products per row`"
        @click="changeGridView(3)"
      >
        <img :src="smallImage">
      </button>
    </div>
    <AltGridViewTooltip :class="{ 'additional-grid-view': controlAltPhoneEnabled }" />
  </div>
</template>

<script setup>
import AltGridViewTooltip from './AltGridViewTooltip';
import useAltGridView from '../composables/useAltGridView';
import { useDevice } from '@modules/discovery/composables';

const emit = defineEmits([
  'updateGridView',
]);

const { isPhone } = useDevice();
const {
  desktopAltEnabled, phoneAltEnabled1, noOfPhoneProds, changeGridView,
  standardImage, smallImage, portraitImage, controlAltDesktopEnabled,
  controlAltPhoneEnabled, selectedGridView,
} = useAltGridView(emit);
</script>
